/**
 * Setear ordenes.
 */
export function setOrdersCompany(state, orders) {
    state.orders = orders
}

/**
 * Reestablecer filtros pictogramas
 */
export function setDataFilterPictogram(state, {product_id, company_id}) {
    state.filter.product_id = product_id;
    state.filter.company_id = company_id;
}

/**
 * Setear pictogramas
 */
export function setPictograms(state, pictograms) {
    state.pictograms = pictograms;
}

/**
 * Setear pictograms_main
 */
export function setPictogramsMain(state, pictograms_main) {
    state.pictograms_main = pictograms_main;
}






